import { Box } from '@mui/material'
import PublicTimelineContent from './PublicTimelineContent'
import TimelineContent from './TimelineContent'
import ThoughtTimelineExtras from './ThoughtTimelineExtras'
import styles from './thoughtchain/thoughtchain.module.scss'

export default function TimelineProcessContent({
  model,
  streaming,
  publicActivity,
  citations,
}) {
  return (
    <Box className={styles.timelineProcess}>
      <ThoughtTimelineExtras extras={model.leadingExtras} streaming={streaming} />
      {model.hasPublicTimeline ? (
        <PublicTimelineContent
          view={model.publicView}
          streaming={streaming}
          hasMore={publicActivity.hasMore}
          loadMore={publicActivity.loadMore}
          citations={citations}
        />
      ) : (
        <TimelineContent view={model.view} streaming={streaming} citations={citations} />
      )}
      <ThoughtTimelineExtras extras={model.trailingExtras} streaming={streaming} />
    </Box>
  )
}
